<template>
    <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M5 9h3l4.5-3.75a.6.6 0 0 1 1 .46v12.58a.6.6 0 0 1-1 .46L8 15H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z" />
        <path d="M16.5 9.5a4 4 0 0 1 0 5" />
        <path d="M19 7a7 7 0 0 1 0 10" />
    </svg>
</template>
